module.exports = __webpack_public_path__ + "73bf2393ad45e972bc8d17b1baf93df3.png";